import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  --background: transparent;
`;

export const TitleStyles = styled.h1`
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0%;
  text-align: center;
  color: #ffffff;
  margin: 0;
  padding: 0 16px 0;
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 500px;
  z-index: 2;
`;

export const ScreenVideoStyles = styled.video`
  position: fixed;
  top: 88px;
  left: 50%;
  transform: translateX(-50%);
  width: 312px;
  height: 481px;
  z-index: 1;
  object-fit: contain;
`;

export const OnboardingFooterContainerStyles = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 500px;
  z-index: 2;
`;
